import { useQuery } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import { CatalogClient, TopLevelCategory } from 'src/WebApiController';

export const useGetCategoryDescription = (
  topLevelCategory?: TopLevelCategory,
  categoryId?: number,
  disabled?: boolean
) => {
  const { activeAccountWebClientConfig } = useAppContext();

  const { trackError } = useClientLogContext();

  const queryKey = [
    'CatalogClient.getCategoryUrlsByIds',
    topLevelCategory,
    categoryId,
  ];

  const shouldQuery =
    !disabled &&
    Boolean(
      activeAccountWebClientConfig.activeAccountId &&
        topLevelCategory &&
        categoryId
    );
  const categoryDescriptionQuery = useQuery({
    queryKey,
    queryFn: async () => {
      if (!shouldQuery || !topLevelCategory || !categoryId) return null;

      const categoryDescription = await new CatalogClient(
        activeAccountWebClientConfig
      ).getCategoryDescriptionById(topLevelCategory, categoryId);

      return categoryDescription;
    },

    enabled: shouldQuery,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    meta: {
      onError: (error: ErrorTypes) => {
        trackError('CatalogClient.getCategoryDescriptionById', error, {
          topLevelCategory,
          categoryId,
        });
      },
    },
  });

  return {
    categoryDescription: categoryDescriptionQuery.data,
    isLoading: categoryDescriptionQuery.isLoading,
  };
};
